<template>
    <div v-if="model">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :end-validations="{required: (!model.periodoAplicacao.start && !model.periodoAplicacao.end) || !!model.periodoEnvio.start}"
                            :range-inline="false"
                            :start-validations="{required: (!model.periodoAplicacao.start && !model.periodoAplicacao.end) || !!model.periodoEnvio.end}"
                            end-label="Até"
                            range
                            start-label="Período de envio"
                            v-model="model.periodoEnvio"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :end-validations="{required: (!model.periodoEnvio.start && !model.periodoEnvio.end) || !!model.periodoAplicacao.start}"
                            :range-inline="false"
                            :start-validations="{required: (!model.periodoEnvio.start && !model.periodoEnvio.end) || !!model.periodoAplicacao.end}"
                            end-label="Até"
                            range
                            right
                            start-label="Período de aplicação"
                            v-model="model.periodoAplicacao"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disabledFields"
                            :options="form.unidades"
                            @change="handleUnidadeChange"
                            default-option-text="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disabledFields"
                            :options="form.infraestruturas"
                            @change="handleInfraestruturaChange"
                            default-option-text="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="disabledFields"
                            :options="form.usuarios"
                            @change="handleUsuarioChange"
                            default-option-text="Todos"
                            label="Aplicador"
                            show-default-option
                            text-field="nome"
                            v-model="model.usuarioId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :disabled="disabledFields"
                            @change="handleProntuarioChange"
                            label="Prontuário"
                            number
                            v-model="model.prontuario"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :disabled="disabledFields"
                            :options="form.sexos"
                            @change="handleSexoChange"
                            default-option-text="Todos"
                            label="Sexo"
                            show-default-option
                            text-field="descricao"
                            v-model="model.sexoId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-select
                            :disabled="disabledFields"
                            :options="form.vacinas"
                            @change="handleVacinaChange"
                            default-option-text="Todas"
                            label="Vacina"
                            show-default-option
                            text-field="vacina"
                            v-model="model.vacinaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            :disabled="disabledFields"
                            :options="form.status"
                            default-option-text="Todos"
                            label="Status"
                            show-default-option
                            v-model="model.status"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :disabled="disabledFields"
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <template v-if="items">
            <rkm-area
                no-margin-top
                title="Totalizadores - Envio"
            >
                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="totalizadores.semInconsistencias"
                            disabled
                            label="Sem inconsistência"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="totalizadores.comInconsistencias"
                            disabled
                            label="Com inconsistência"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :value="totalizadores.totalEnvios"
                            disabled
                            label="Total"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-area
                no-margin-top
                title="Resultado"
            >
                <template v-slot:trailing>
                    <rkm-dropdown
                        class="mr-2"
                        color="primary"
                        cols="1"
                        menu-class="auto-scroll"
                        no-caret
                        small
                        title="Colunas"
                        v-rkm-tooltip.hover
                    >
                        <template v-slot:button-content>
                            <rkm-icon icon="columns" />
                        </template>

                        <rkm-form-checkbox
                            :indeterminate="indeterminate"
                            @change="selectAll"
                            class="mx-2"
                            v-model="selectedAll"
                        >
                            Todas
                        </rkm-form-checkbox>

                        <rkm-form-checkbox-group
                            :options="optionalColumns"
                            class="mx-2"
                            stacked
                            text-field="label"
                            v-model="selectedCols"
                            value-field="key"
                        />
                    </rkm-dropdown>

                    <rkm-button
                        @click="print"
                        color="info"
                        small
                        title="Imprimir"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>

                    <rkm-button
                        @click="exportTo"
                        color="info"
                        small
                        title="Exportar"
                    >
                        <rkm-icon icon="file-export" />
                    </rkm-button>
                </template>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-table
                            :fields="columns"
                            :items="items"
                            :perPage="100"
                            responsive
                        >
                            <template v-slot:cell(cnsSolicitante)="{item}">
                                {{formatCns(item.cnsSolicitante)}}
                            </template>

                            <template v-slot:cell(paciente)="{item}">
                                {{item.pacienteNome}} / {{item.pacienteCns}}
                            </template>

                            <template v-slot:cell(inconsistencias)="{item}">
                                <template v-if="item.inconsistencias.length > 0">
                                    <div
                                        v-for="(inconsistencia, i) in item.inconsistencias"
                                        :key="i"
                                    >
                                        {{inconsistencia.resposta}}
                                    </div>
                                </template>

                                <template v-else>
                                    -
                                </template>
                            </template>
                        </rkm-table>
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </template>
    </div>
</template>

<script>
// Mixins.
import {error, file, formats, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        disabledFields() {
            return (this.model.periodoEnvio.start === null || this.model.periodoEnvio.end === null) && (this.model.periodoAplicacao.start === null || this.model.periodoAplicacao.end === null)
        },
        columns() {
            return this.fields.table.filter(c => (c.fixed || false) || this.selectedCols.includes(c.key))
        },
        optionalColumns() {
            return this.fields.table.filter(field => !(field.fixed || false))
        },
    },
    created() {
        this.repositories = {
            exportacao: this.getConectaSusRepository('exportacao.integracao'),
            impressao: this.getConectaSusRepository('impressao.integracao.ria'),
            relatorioEnvio: this.getConectaSusRepository('integracao.ria.relatorioEnvio'),
        }
    },
    data() {
        return {
            form: null,
            fields: {
                table: [
                    {fixed: true, key: 'dataHoraEnvio', label: 'Data/Hora envio', sortable: true},
                    {key: 'identificadorRnds', label: 'Identificador do RNDS', sortable: true},
                    {key: 'identificadorSolicitante', label: 'Identificador do solicitante', sortable: true},
                    {key: 'cnsSolicitante', label: 'CNS do solicitante', sortable: true},
                    {key: 'identificadorDocumento', label: 'Identificador do documento', sortable: true},
                    {key: 'identificadorComposicao', label: 'Identificador da composição', sortable: true},
                    {key: 'identificadorImunizacao', label: 'Identificador da imunização', sortable: true},
                    {fixed: true, key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true},
                    {key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true},
                    {fixed: true, key: 'usuarioNome', label: 'Aplicador', sortable: true},
                    {fixed: true, key: 'usuarioCns', label: 'CNS do aplicador', sortable: true},
                    {fixed: true, key: 'pacienteNome', label: 'Nome', sortable: true},
                    {fixed: true, key: 'pacienteCns', label: 'CNS', sortable: true},
                    {fixed: true, key: 'pacienteDataNascimento', label: 'Data de nascimento', sortable: true},
                    {key: 'pacienteIdade', label: 'Idade', sortable: true},
                    {key: 'pacienteSexo', label: 'Sexo', sortable: true},
                    {fixed: true, key: 'data', label: 'Data', sortable: true},
                    {fixed: true, key: 'vacina', label: 'Vacina', sortable: true},
                    {fixed: true, key: 'lote', label: 'Lote', sortable: true},
                    {fixed: true, key: 'dataValidadeLote', label: 'Data de validade do lote', sortable: true},
                    {fixed: true, key: 'grupoAtendimentoNome', label: 'Grupo de atendimento', sortable: true},
                    {fixed: true, key: 'estrategiaNome', label: 'Estratégia', sortable: true},
                    {key: 'produtorNome', label: 'Produtor', sortable: true},
                    {formatter: (value) => value ? 'SIM' : 'NÃO', key: 'gestante', label: 'Gestante', sortable: true},
                    {formatter: (value) => value ? 'SIM' : 'NÃO', key: 'puerpera', label: 'Puerpera', sortable: true},
                    {fixed: true, key: 'inconsistencias', label: 'Detalhes das inconsistências', sortable: true},
                ],
            },
            indeterminate: true,
            items: null,
            model: null,
            others: {moment},
            selectedAll: false,
            selectedCols: [],
            totalizadores: null,
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.relatorioEnvio.create()
                .then((response) => {
                    this.form = response.data.form
                    this.model = response.data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        search() {
            const request = {
                periodoEnvio: {
                    start: this.model.periodoEnvio.start ? this.others.moment(this.model.periodoEnvio.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodoEnvio.end ? this.others.moment(this.model.periodoEnvio.end).format('DD/MM/YYYY') : null,
                },
                periodoAplicacao: {
                    start: this.model.periodoAplicacao.start ? this.others.moment(this.model.periodoAplicacao.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodoAplicacao.end ? this.others.moment(this.model.periodoAplicacao.end).format('DD/MM/YYYY') : null,
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                usuarioId: this.model.usuarioId,
                prontuario: this.model.prontuario,
                sexoId: this.model.sexoId,
                vacinaId: this.model.vacinaId,
                status: this.model.status,
            }

            this.setLoading()

            this.repositories.relatorioEnvio.index(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.items = Object.assign(response.data.resultado)
                    this.totalizadores = Object.assign(response.data.totalizadores)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.form.unidades = []
            this.form.infraestruturas = []
            this.form.usuarios = []
            this.form.sexos = []
            this.form.vacinas = []
            this.form.status = []

            this.model.periodoEnvio = {
                start: null,
                end: null,
            }

            this.model.periodoAplicacao = {
                start: null,
                end: null,
            }

            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.usuarioId = null
            this.model.prontuario = null
            this.model.sexoId = null
            this.model.vacinaId = null
            this.model.status = null
            this.items = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        print() {
            this.setLoading()

            const request = {
                periodoEnvio: {
                    start: this.model.periodoEnvio.start ? this.others.moment(this.model.periodoEnvio.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodoEnvio.end ? this.others.moment(this.model.periodoEnvio.end).format('DD/MM/YYYY') : null,
                },
                periodoAplicacao: {
                    start: this.model.periodoAplicacao.start ? this.others.moment(this.model.periodoAplicacao.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodoAplicacao.end ? this.others.moment(this.model.periodoAplicacao.end).format('DD/MM/YYYY') : null,
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                usuarioId: this.model.usuarioId,
                prontuario: this.model.prontuario,
                sexoId: this.model.sexoId,
                vacinaId: this.model.vacinaId,
                status: this.model.status,
                selectedCols: this.columns
                    .filter(column => column.key !== 'actions')
                    .map(column => ({
                        class: column.class,
                        key: this.camelToSnake(column.key),
                        label: column.label,
                    }))
            }

            this.repositories.impressao.relatorioEnvio(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportTo() {
            this.setLoading()

            const request = {
                periodoEnvio: {
                    start: this.model.periodoEnvio.start ? this.others.moment(this.model.periodoEnvio.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodoEnvio.end ? this.others.moment(this.model.periodoEnvio.end).format('DD/MM/YYYY') : null,
                },
                periodoAplicacao: {
                    start: this.model.periodoAplicacao.start ? this.others.moment(this.model.periodoAplicacao.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodoAplicacao.end ? this.others.moment(this.model.periodoAplicacao.end).format('DD/MM/YYYY') : null,
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                usuarioId: this.model.usuarioId,
                prontuario: this.model.prontuario,
                sexoId: this.model.sexoId,
                vacinaId: this.model.vacinaId,
                status: this.model.status,
                selectedCols: this.columns
                    .filter(column => column.key !== 'actions')
                    .map(column => ({
                        class: column.class,
                        key: this.camelToSnake(column.key),
                        label: column.label,
                    }))
            }

            this.repositories.exportacao.riaRelatorioEnvio(this.camelObjectKeysToSnakeRecursive(request))
                .then(({data, headers}) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUnidadeChange(value) {
            this.form.infraestruturas = []
            this.form.usuarios = []
            this.form.sexos = []
            this.form.vacinas = []
            this.form.status = []
            this.model.infraestruturaId = null
            this.model.usuarioId = null
            this.model.prontuario = null
            this.model.sexoId = null
            this.model.vacinaId = null
            this.model.status = null
            this.items = null

            const request = {
                listar: 'infraestruturas',
                periodoEnvio: {
                    start: this.model.periodoEnvio.start ? this.others.moment(this.model.periodoEnvio.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodoEnvio.end ? this.others.moment(this.model.periodoEnvio.end).format('DD/MM/YYYY') : null,
                },
                periodoAplicacao: {
                    start: this.model.periodoAplicacao.start ? this.others.moment(this.model.periodoAplicacao.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodoAplicacao.end ? this.others.moment(this.model.periodoAplicacao.end).format('DD/MM/YYYY') : null,
                },
                unidadeId: value,
            }

            this.setLoading()

            this.repositories.relatorioEnvio.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.sexos = Object.assign(response.data.sexos)
                    this.form.vacinas = Object.assign(response.data.vacinas)
                    this.form.status = Object.assign(response.data.status)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleInfraestruturaChange(value) {
            this.form.usuarios = []
            this.form.sexos = []
            this.form.vacinas = []
            this.form.status = []
            this.model.usuarioId = null
            this.model.prontuario = null
            this.model.sexoId = null
            this.model.vacinaId = null
            this.model.status = null
            this.items = null

            const request = {
                listar: 'usuarios',
                periodoEnvio: {
                    start: this.model.periodoEnvio.start ? this.others.moment(this.model.periodoEnvio.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodoEnvio.end ? this.others.moment(this.model.periodoEnvio.end).format('DD/MM/YYYY') : null,
                },
                periodoAplicacao: {
                    start: this.model.periodoAplicacao.start ? this.others.moment(this.model.periodoAplicacao.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodoAplicacao.end ? this.others.moment(this.model.periodoAplicacao.end).format('DD/MM/YYYY') : null,
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: value,
            }

            this.setLoading()

            this.repositories.relatorioEnvio.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.usuarios = Object.assign(response.data.usuarios)
                    this.form.sexos = Object.assign(response.data.sexos)
                    this.form.vacinas = Object.assign(response.data.vacinas)
                    this.form.status = Object.assign(response.data.status)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUsuarioChange(value) {
            this.form.sexos = []
            this.form.vacinas = []
            this.form.status = []
            this.model.prontuario = null
            this.model.sexoId = null
            this.model.vacinaId = null
            this.model.status = null
            this.items = null

            const request = {
                listar: 'sexos',
                periodoEnvio: {
                    start: this.model.periodoEnvio.start ? this.others.moment(this.model.periodoEnvio.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodoEnvio.end ? this.others.moment(this.model.periodoEnvio.end).format('DD/MM/YYYY') : null,
                },
                periodoAplicacao: {
                    start: this.model.periodoAplicacao.start ? this.others.moment(this.model.periodoAplicacao.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodoAplicacao.end ? this.others.moment(this.model.periodoAplicacao.end).format('DD/MM/YYYY') : null,
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                usuarioId: value,
            }

            this.setLoading()

            this.repositories.relatorioEnvio.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.sexos = Object.assign(response.data.sexos)
                    this.form.vacinas = Object.assign(response.data.vacinas)
                    this.form.status = Object.assign(response.data.status)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleProntuarioChange(value) {
            this.form.sexos = []
            this.form.vacinas = []
            this.form.status = []
            this.model.sexoId = null
            this.model.vacinaId = null
            this.model.status = null
            this.items = null

            const request = {
                listar: 'sexos',
                periodoEnvio: {
                    start: this.model.periodoEnvio.start ? this.others.moment(this.model.periodoEnvio.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodoEnvio.end ? this.others.moment(this.model.periodoEnvio.end).format('DD/MM/YYYY') : null,
                },
                periodoAplicacao: {
                    start: this.model.periodoAplicacao.start ? this.others.moment(this.model.periodoAplicacao.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodoAplicacao.end ? this.others.moment(this.model.periodoAplicacao.end).format('DD/MM/YYYY') : null,
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                usuarioId: this.model.usuarioId,
                prontuario: value,
            }

            this.setLoading()

            this.repositories.relatorioEnvio.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.sexos = Object.assign(response.data.sexos)
                    this.form.vacinas = Object.assign(response.data.vacinas)
                    this.form.status = Object.assign(response.data.status)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleSexoChange(value) {
            this.form.vacinas = []
            this.form.status = []
            this.model.vacinaId = null
            this.model.status = null
            this.items = null

            const request = {
                listar: 'vacinas',
                periodoEnvio: {
                    start: this.model.periodoEnvio.start ? this.others.moment(this.model.periodoEnvio.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodoEnvio.end ? this.others.moment(this.model.periodoEnvio.end).format('DD/MM/YYYY') : null,
                },
                periodoAplicacao: {
                    start: this.model.periodoAplicacao.start ? this.others.moment(this.model.periodoAplicacao.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodoAplicacao.end ? this.others.moment(this.model.periodoAplicacao.end).format('DD/MM/YYYY') : null,
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                usuarioId: this.model.usuarioId,
                prontuario: this.model.prontuario,
                sexoId: value,
            }

            this.setLoading()

            this.repositories.relatorioEnvio.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.vacinas = Object.assign(response.data.vacinas)
                    this.form.status = Object.assign(response.data.status)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleVacinaChange(value) {
            this.form.status = []
            this.model.status = null
            this.items = null

            const request = {
                listar: 'status',
                periodoEnvio: {
                    start: this.model.periodoEnvio.start ? this.others.moment(this.model.periodoEnvio.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodoEnvio.end ? this.others.moment(this.model.periodoEnvio.end).format('DD/MM/YYYY') : null,
                },
                periodoAplicacao: {
                    start: this.model.periodoAplicacao.start ? this.others.moment(this.model.periodoAplicacao.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodoAplicacao.end ? this.others.moment(this.model.periodoAplicacao.end).format('DD/MM/YYYY') : null,
                },
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                usuarioId: this.model.usuarioId,
                prontuario: this.model.prontuario,
                sexoId: this.model.sexoId,
                vacinaId: value,
            }

            this.setLoading()

            this.repositories.relatorioEnvio.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.status = Object.assign(response.data.status)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        selectAll(selected) {
            this.selectedCols = selected ? this.optionalColumns.map(c => c.key) : []
        },
    },
    mixins: [error, file, formats, repository, stringCase],
    mounted() {
        this.load()
    },
    watch: {
        'model.periodoEnvio': {
            deep: true,
            handler(value) {
                this.form.unidades = []
                this.form.infraestruturas = []
                this.form.usuarios = []
                this.form.sexos = []
                this.form.vacinas = []
                this.form.status = []

                this.model.periodoAplicacao = {
                    start: null,
                    end: null,
                }

                this.model.unidadeId = null
                this.model.infraestruturaId = null
                this.model.usuarioId = null
                this.model.prontuario = null
                this.model.sexoId = null
                this.model.vacinaId = null
                this.model.status = null
                this.items = null

                if (value.start === null || value.end === null)  {
                    return
                }

                const request = {
                    listar: 'unidades',
                    periodoEnvio: {
                        start: this.others.moment(value.start).format('DD/MM/YYYY'),
                        end: this.others.moment(value.end).format('DD/MM/YYYY'),
                    },
                }

                this.setLoading()

                this.repositories.relatorioEnvio.list(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.form.unidades = Object.assign(response.data.unidades)
                        this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                        this.form.usuarios = Object.assign(response.data.usuarios)
                        this.form.sexos = Object.assign(response.data.sexos)
                        this.form.vacinas = Object.assign(response.data.vacinas)
                        this.form.status = Object.assign(response.data.status)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            },
        },
        'model.periodoAplicacao': {
            deep: true,
            handler(value) {
                this.form.unidades = []
                this.form.infraestruturas = []
                this.form.usuarios = []
                this.form.sexos = []
                this.form.vacinas = []
                this.form.status = []
                this.model.unidadeId = null
                this.model.infraestruturaId = null
                this.model.usuarioId = null
                this.model.prontuario = null
                this.model.sexoId = null
                this.model.vacinaId = null
                this.model.status = null
                this.items = null

                if (value.start === null || value.end === null)  {
                    return
                }

                const request = {
                    listar: 'unidades',
                    periodoEnvio: {
                        start: this.model.periodoEnvio.start ? this.others.moment(this.model.periodoEnvio.start).format('DD/MM/YYYY') : null,
                        end: this.model.periodoEnvio.start ? this.others.moment(this.model.periodoEnvio.end).format('DD/MM/YYYY') : null,
                    },
                    periodoAplicacao: {
                        start: this.others.moment(value.start).format('DD/MM/YYYY'),
                        end: this.others.moment(value.end).format('DD/MM/YYYY'),
                    },
                }

                this.setLoading()

                this.repositories.relatorioEnvio.list(this.camelObjectKeysToSnakeRecursive(request))
                    .then(response => {
                        this.form.unidades = Object.assign(response.data.unidades)
                        this.form.infraestruturas = Object.assign(response.data.infraestruturas)
                        this.form.usuarios = Object.assign(response.data.usuarios)
                        this.form.sexos = Object.assign(response.data.sexos)
                        this.form.vacinas = Object.assign(response.data.vacinas)
                        this.form.status = Object.assign(response.data.status)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            },
        },
    },
}
</script>